import { Injectable } from '@angular/core';
import {Router, RouterEvent, NavigationEnd, NavigationStart, NavigationCancel, NavigationError} from '@angular/router';
import { filter } from 'rxjs/operators';
import {NavigationTemplate} from "@app/Classes/NavigationTemplate";
import {Title} from "@angular/platform-browser";
import {environment} from "@env/environment";
declare const gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private navigationTitle: string = "";
  private previousURL: string = null;
  private currentURL: string = null;

  constructor(private _router: Router, private titleService: Title){
    _router.events
      .pipe(filter((event: RouterEvent) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousURL = this.currentURL;
        this.currentURL = event.urlAfterRedirects;
      });
    if (environment.environment == 'local') {

      _router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
        gtag('event', 'page_view', {
          page_path: event.urlAfterRedirects
        })
      })

      _router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          var title = this.getTitle(_router.routerState, _router.routerState.root).join(' > ');
          titleService.setTitle(title);
        }
      });
    }
  }

  getTitle(state, parent) {
    var data = [];
    if(parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if(state && parent) {
      data.push(... this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }

  public getPreviousUrl(){
    return this.previousURL;
  }

  public getNavigationTitle(){
    return this.navigationTitle;
  }

  public setNavigationTitle(title: string){
    this.navigationTitle = title;
  }

  public async navigateWithParams(route: string,params:any){
    await this._router.navigate(([route,params]));
  }

  public async navigateWithParamsAndQuery(route: string,params:any,queryString:string){
    await this._router.navigate(([route,params]),{queryParams:{q:queryString}});
  }

  public async navigateWithParamsAndQueryV2(route: string, params: any, query: object){
    await this._router.navigate(([route,params]),{queryParams: query});
  }

  public async navigateWithQuery(route: string,queryString:string){
    await this._router.navigate(([route]),{queryParams:{q:queryString}});
  }

  public async navigateWithQueryV2(route: string, query: object){
    await this._router.navigate([route], {queryParams: query});
  }

  public async navigate(route: string, title?: string){
    if (title != null){
      this.setNavigationTitle(title);
    }
    try{
      await this._router.navigate([route]);
    } catch (error ){
      console.log(error);
    }

  }

  public getNavigationTemplate(){
    // Define navigation templates
    let navTemplates: NavigationTemplate[] = [];
    let overview = new NavigationTemplate("overview","overview","Store Overview", "Store<br>Overview");
    let allEval = new NavigationTemplate("eval","evals","Store Evaluations", "Store<br>Evaluations");
    let dManagement = new NavigationTemplate("management","analyze","Data Management", "Data<br>Management");
    let hImages = new NavigationTemplate("store-images","historical-image","Store Images", "Store Images");
    let adminData = new NavigationTemplate("admin-data","admin","Administrator Data Page", "Admin Page");
    let ownedStore = new NavigationTemplate("owned-store","owned-store","Owned Store Management", "Owned Stores");

    // Get roles for navigation setup
    let roles = JSON.parse(localStorage.getItem("loggedInAs"))?.role;
    if(roles == null){
      navTemplates.push(hImages);
      return navTemplates;
    }

    // Define navigation setup based upon roles with top-down approach
    if(roles.includes("Administrator")){
      navTemplates.push(overview,allEval,dManagement,hImages,adminData,ownedStore);
      return navTemplates;
    }else if(roles.includes("EnergyAnalyst")){
      navTemplates.push(overview,allEval,dManagement,hImages);
      return navTemplates;
    }else if(roles.includes("Default")){
      navTemplates.push(allEval,hImages, overview);
      return navTemplates;
    }else{
      navTemplates.push(hImages);
      return navTemplates;
    }
  }
}
